<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">

        <div class="re-el-form__flex">
          <el-form-item label="项目ID"
                        prop="projectid">
            <el-input placeholder="请输入项目ID"
                      v-model="search.projectid"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="评价时间"
                        prop="created_at">
            <el-date-picker
                v-model="search.created_at"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                clearable>
            </el-date-picker>
          </el-form-item>

          <el-form-item label="用户ID"
                        prop="userid">
            <el-input placeholder="请输入用户ID"
                      v-model="search.userid"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="整体体验"
                        prop="star">
            <el-select v-model="search.star"
                       placeholder="请选择整体体验"
                       class="width-max"
                       clearable>
              <el-option
                  v-for="item in starLabels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="客户名称"
                        prop="customername">
            <el-input placeholder="请输入客户名称"
                      v-model="search.customername"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="工单ID"
                        prop="orderid">
            <el-input placeholder="请输入工单ID"
                      v-model="search.orderid"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="评价关键字"
                        prop="content">
            <el-input placeholder="请输入评价关键字"
                      v-model="search.content"
                      clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       native-type="submit">搜索
            </el-button>
            <el-button icon="sj-icon-export"
                       @click="onExportSearch()">按搜索结果导出
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="true">
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button type="primary" size="mini" @click="onMultiExport">批量导出</el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                @selection-change="handleSelectionChange"
                style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="id"
                         label="ID"></el-table-column>
        <el-table-column prop="userid"
                         label="用户ID"
        ></el-table-column>
        <el-table-column prop="tasktitle"
                         label="任务名称"
        ></el-table-column>
        <el-table-column prop="orderid"
                         label="工单ID"
        ></el-table-column>
        <el-table-column prop="created_at"
                         label="评价时间"
        ></el-table-column>
        <el-table-column prop="content"
                         label="评价"
        ></el-table-column>
        <el-table-column prop="star"
                         label="整体体验"
                         :formatter="formatStar"
        ></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],

  data () {
    return {
      multipleSelection: [],
      table: [],
      search: {
        projectid: null,
        created_at: [],
        userid: null,
        star: this.$route.query.star * 1 || null,
        customername: null,
        orderid: null,
        content: null,
      },
      starLabels: [
        {
          value: 1,
          label: '题目繁杂'
        },
        {
          value: 2,
          label: '操作困难'
        },
        {
          value: 3,
          label: '还不错'
        },
        {
          value: 4,
          label: '感觉挺好'
        },
        {
          value: 5,
          label: '非常好'
        }
      ],
      exportHeader: [
        {
          key: 'id',
          text: 'ID'
        },
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'tasktitle',
          text: '任务名称',
        },
        {
          key: 'orderid',
          text: '工单ID',
        },
        {
          key: 'created_at',
          text: '评价时间',
        },
        {
          key: 'content',
          text: '评价',
        },
        {
          key: 'star',
          text: '整体体验',
        },
      ],
    }
  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOrderCommentTable', params)
    },
    onExportSearch () {
      const formatStar = this.formatStar
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: function (data) {
          data.current_page > 1 && data.data.splice(0, 1)
          for (let i in data.data) {
            if (data.data.hasOwnProperty(i)) {
              data.data[i].star = formatStar(null, null, data.data[i].star)
            }
          }
          return data
        },
      })
    },
    formatStar (row, column, cellValue) {
      for (let i in this.starLabels) {
        if (this.starLabels.hasOwnProperty(i) && this.starLabels[i].value === cellValue * 1) {
          return this.starLabels[i].label
        }
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    onMultiExport () {
      if (!this.multipleSelection || this.multipleSelection.length <= 0) {
        this.$message.error('勾选数量为空')
        return
      }
      let data = filter.copyJson(this.multipleSelection)
      data.forEach((row) => {
        row.star = this.formatStar(null, null, row.star)
      })
      this.$export(`${this.$route.meta.title}`, data, {
        fileHeader: this.exportHeader,
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformOrderCommentTable.vue